var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBook2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#909090;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M696.4,84.7h-58.1V26.5c0-7.8-3.4-15.2-9.4-20.2c-5.9-5-13.8-7.2-21.5-5.9L99.3,85 c-12.8,2.1-22.1,13.2-22.1,26.1v662.4c0,14.6,11.9,26.5,26.5,26.5h592.7c14.6,0,26.5-11.9,26.5-26.5V111.1 C722.8,96.5,711,84.7,696.4,84.7z M130.1,133.5l455.2-75.8v608.8l-455.2,75.8V133.5z M669.9,747.1H423.7l192.4-32 c12.8-2.1,22.1-13.2,22.1-26.1V137.6h31.7L669.9,747.1L669.9,747.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M490.4,176.5l-273.4,42.3c-14.4,2.2-24.3,15.8-22.1,30.2c2,13.1,13.3,22.4,26.1,22.4c1.3,0,2.7-0.1,4.1-0.3 l273.4-42.3c14.4-2.2,24.3-15.8,22.1-30.2C518.3,184.1,504.8,174.2,490.4,176.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBook2);
export default __webpack_public_path__ + "static/media/iconBook2.bdf241602da24aec140483633b02901a.svg";
export { ForwardRef as ReactComponent };